import { RestClient } from '@libs/rest-client';
import { strToDate } from '@ps-smart-cp/ppfw-client';
import { AccountingPolicy, ArticleSetting } from '../models';
import type { AccountingPolicyRaw, ArticleSettingRaw } from '../models';

interface CompanyIdentity {
  companyName: string;
  companyCode: string;
}

async function fetchCompanyCtx() {
  const res = await RestClient.fa.get<{
    company: CompanyIdentity;
    accountingPolicy: Omit<AccountingPolicyRaw, 'beginningYm'>;
    articleSetting: ArticleSettingRaw;
  }>('/company/context');

  return {
    company: res.company,
    accountingPolicy: AccountingPolicy.fromRaw(res.accountingPolicy),
    articleSetting: ArticleSetting.fromRaw(res.articleSetting),
  };
}

async function fetchCurrentProcessingMonth() {
  const processingMonth = await RestClient.fa.get<{ processingMonth: string; carryOverState: string }>(
    '/company/processing-month/current',
  );
  const date = strToDate(processingMonth.processingMonth);
  const state = processingMonth.carryOverState;

  if (!date) throw new Error('processing month should not be null');
  return {
    processingMonth: date,
    carryOverState: state,
  };
}

export { fetchCompanyCtx, fetchCurrentProcessingMonth };
export type { CompanyIdentity };
